import { render, staticRenderFns } from "./MobileSectionSliderNewCopy.vue?vue&type=template&id=a8439036&scoped=true&"
import script from "./MobileSectionSliderNewCopy.vue?vue&type=script&lang=js&"
export * from "./MobileSectionSliderNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./MobileSectionSliderNewCopy.vue?vue&type=style&index=0&id=a8439036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8439036",
  null
  
)

export default component.exports